import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AbstractCrudService } from '../service/abstract.crud.service';

@Injectable({
  providedIn: 'root'
})
export class FaltaMedicaService extends AbstractCrudService {

  protected getBaseUrlPrivate(): string {
    return super.getBaseUrlPrivate() + 'faltasMedicas';
  }

  protected getBaseUrlPublic(): string {
    throw new Error("Método não suportado!");
  }

  listarComProjecao(dataInicial: string, dataFinal: string): Observable<any> {
    return this.http.get(`${this.getBaseUrlPrivate()}/filtroPorData/comProjecao/${dataInicial}/${dataFinal}`);
  }

}
